<template>
    <path fill-rule="evenodd" d="M9.333 8.813v10.124c0 .311-.252.563-.562.563H7.646c-.31 0-.563-.252-.563-.563V8.813c0-.31.252-.562.563-.562H8.77c.31 0 .562.252.562.563zm4.688-.563h-1.125c-.31 0-.563.252-.563.563v10.124c0 .311.252.563.563.563h1.125c.31 0 .562-.252.562-.563V8.813c0-.31-.252-.562-.562-.562zm6.187-4.5c.622 0 1.125.504 1.125 1.125v.563c0 .31-.252.562-.562.562h-.938v15.75c0 1.243-1.007 2.25-2.25 2.25h-13.5c-1.242 0-2.25-1.007-2.25-2.25V6H.896c-.31 0-.563-.252-.563-.563v-.562c0-.621.504-1.125 1.125-1.125h3.488l1.595-2.658C6.948.415 7.68 0 8.47 0h4.725c.79 0 1.523.415 1.93 1.092L16.72 3.75h3.488zm-12.638 0h6.526l-.818-1.363c-.05-.085-.142-.137-.24-.137H8.63c-.1 0-.19.052-.242.137L7.57 3.75zM17.583 6h-13.5v15.469c0 .155.126.281.282.281h12.937c.155 0 .281-.126.281-.281V6z"/>
</template>

<script>
export default {
    name: 'deleteV2Icon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 22 24');
    }
}
</script>

<style scoped>

</style>